<div style="float: right; padding-right: 15px;">
    <a [routerLink]="['/'+openView]">
        <button type="button" class="btn btn-primary">{{'FUNCTION-BUTTONS.ADD' | translate}}</button>
    </a>
</div>
<br/>
<br/><br/>